import React, { Component, Fragment } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import AssessmentResultConfiguration from './AssessmentResultConfiguration';
import AssessmentAccessModal from './AssessmentAccessModal';
import moment from 'moment-timezone';

import './Home.css';

class AssessmentResult extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accessModalShow: false
        }
    }

    assessmentSelectionHandler = (aid, assessmentDate ) => {
        this.props.assessmentSelectionHandler(aid, assessmentDate);
    }

    archiveHandler = (e) => {
        let idParts = e.target.id.split("_");
        if (idParts[0] == "Del") {
            // Mark only when archiving
            this.props.assessmentDeleteHandler(idParts[1], 1);
            e.stopPropagation();
        }
    }

    accessClickHandler = (e) => {
        this.setState({ accessModalShow: true });
        e.stopPropagation();
    }

    assessmentCopyHandler = (e) => {
        this.props.assessmentCopyHandler(this.props.assessmentId);
        e.stopPropagation();
    }

    accessCloseHandler = () => {
        this.setState({ accessModalShow: false });
    }

    render = () => {
        let mCreateDate = moment.utc(this.props.createDate).tz(moment.tz.guess());
        // Could embed this in the html but need the string elsewhere:  let sCreateDate = <Moment format="MMM-DD-YYYY hh:mm A">{mCreateDate}</Moment>
        let sCreateDate = mCreateDate.format("MMM-DD-YYYY hh:mm A");
        let deleteId = "Del_" + this.props.assessmentId;

        return (
            <Fragment>

                <ListGroupItem
                    className="home_assessmentResult"
                    onClick={this.assessmentSelectionHandler.bind(this, this.props.assessmentId, sCreateDate)}
                    key={this.props.assessmentId}>
                    Assessment {sCreateDate}
                    <Button className="home_AssessmentOpenButton" variant="primary" size="sm">Open</Button>
                    {this.props.isAdmin &&
                        <span className="home_AssessmentResultCommands">
                        <Button className="home_AssessmentResultAccess" variant="secondary" size="sm" onClick={this.accessClickHandler}>Grant Others Access</Button>
                        <Button id={deleteId} className="home_AssessmentResultDelete" variant="secondary" size="sm" onClick={this.archiveHandler}>Archive</Button>
                        {this.props.canCopyAssessment &&
                            <Button className="home_AssessmentResultCopy" variant="secondary" size="sm" onClick={this.assessmentCopyHandler}>Copy</Button>
                        }
                        </span>
                    }
                </ListGroupItem>
                <Card>
                    <Card.Body>
                        <Form.Group controlId={this.props.assessmentId}>
                            <AssessmentResultConfiguration
                                configurationItems={this.props.configurationItems}
                            />
                        </Form.Group>

                    </Card.Body>
                </Card>
                <AssessmentAccessModal
                    assessmentId={this.props.assessmentId}
                    show={this.state.accessModalShow}
                    sCreateDate={sCreateDate}
                    closeHandler={this.accessCloseHandler}
                    providerId={this.props.providerId}
                    patientFn={this.props.patientFn}
                    patientLn={this.props.patientLn}
                    patientBd={this.props.patientBd}
                    key={this.state.accessModalShow}
                />
            </Fragment>
        )
    }
}

export default AssessmentResult;


// WEBPACK FOOTER //
// ./src/components/Home/AssessmentResult.js